import React, { createContext } from "react";
import useLoading from "../custom_hooks/useLoading";
import LoadingOverlay from "../components/loading/LoadingOverlay";

let LoadingContext;
let { Provider } = (LoadingContext = createContext());

let LoadingProvider = ({ children }) => {
  let { loadingComponent, showLoading, hideLoading, color } = useLoading();
  return (
    <Provider value={{ loadingComponent, showLoading, hideLoading, color }}>
      <LoadingOverlay color={color} />
      {children}
    </Provider>
  );
};

export { LoadingContext, LoadingProvider };